export default {
  CashierService: {
    is: 'Gjaldkeraþjónusta',
    en: 'Cashier service',
  },
  CorporateBankingService: {
    is: 'Fyrirtækjaþjónusta',
    en: 'Corporate banking service',
  },
  FinanceConsultation: {
    is: 'Fjármálaráðgjöf',
    en: 'Finance consultation',
  },
  MailDelivery: {
    is: 'Póstafgreiðsla',
  },
  RetailBankingService: {
    is: 'Einstaklingsþjónusta',
    en: 'Retail banking service',
  },
  ServiceVisit: {
    is: 'Þjónustuheimsóknir',
    en: 'Service visit',
  },
};
